'use client';
import React from 'react';

interface ContextProps {
  label?: string;
  meta?: any;
}

// Set Context
export const AnalyticsContext = React.createContext<ContextProps>({
  label: undefined,
  meta: undefined,
});
